import React from 'react';

export default class ReportFrameOperationBar extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = { spinning: false };
  }

  refresh() {
    this.setState({ spinning: true });
    this.props.refreshReport();
    setTimeout(() => this.setState({ spinning: false }), 700);
  }

  render() {
    return (
      <div className='rf-toolbar'>
        <button
          className='icon-btn'
          disabled
          title='First page'
        >
          <i className='fa-solid fa-chevrons-left' />
        </button>
        <button
          className='icon-btn'
          disabled
          title='Previous page'
        >
          <i className='fa-solid fa-chevron-left' />
        </button>
        <span className='rf-tb-pageinfo'>
          <b>1</b> of 1
        </span>
        <button
          className='icon-btn'
          disabled
          title='Next page'
        >
          <i className='fa-solid fa-chevron-right' />
        </button>

        <span className='rf-tb-divider' />
        <span className='rf-tb-group-label'>Export</span>

        <button
          className='icon-btn'
          title='Export to PDF'
          onClick={() => this.props.downloadReport('PDF')}
        >
          <i className='fa-solid fa-file' />
          <span className='rf-tagfmt'>PDF</span>
        </button>
        <button
          className='icon-btn'
          title='Export to Excel'
          onClick={() => this.props.downloadReport('EXCELOPENXML')}
        >
          <i className='fa-solid fa-file' />
          <span className='rf-tagfmt'>XLS</span>
        </button>
        <button
          className='icon-btn'
          title='Export to Word'
          onClick={() => this.props.downloadReport('WORDOPENXML')}
        >
          <i className='fa-solid fa-file' />
          <span className='rf-tagfmt'>DOC</span>
        </button>

        <span className='rf-tb-divider' />

        <button
          className='icon-btn'
          title='Print'
          onClick={() => this.props.printReport()}
        >
          <i className='fa-solid fa-print' />
        </button>
        <button
          className='icon-btn'
          title='Refresh'
          onClick={() => this.refresh()}
        >
          <i className={`fa-solid fa-arrows-rotate${this.state.spinning ? ' fa-spin' : ''}`} />
        </button>
      </div>
    );
  }
}
